/* lv-slider-paski (15.10.2026): paski pod sliderem HOME (sekcja slideshow). Aktywny pasek wypelnia sie w czasie zmiany
   slajdu (ustawienie "autorotate_speed"), poprzednie sa pelne - wzor: paski na zdjeciach kart produktow (lv-galeria-karty.js).
   Automatyczna zmiana slajdu idzie stad (koniec animacji paska), nie z Flickity: sekcja dostaje data-autorotate="false".
   Klik w pasek = przejscie do slajdu i odliczanie od nowa. Pauza: kursor nad sliderem/paskami, dotyk, fokus klawiatury,
   karta w tle, slider poza ekranem. Dane: div.lv-slider-paski[data-lv-slider="<id slideshow-component>"][data-lv-czas="ms"]. */
(function () {
  function podepnij(w) {
    if (w._lvSp) return;
    var komp = document.getElementById(w.dataset.lvSlider);
    if (!komp) return;
    w._lvSp = true;
    var paski = Array.prototype.slice.call(w.querySelectorAll('.lv-slider-paski__pasek'));
    var n = paski.length, czas = parseInt(w.dataset.lvCzas, 10) || 0, biezacy = -1;
    var tresc = komp.querySelector('.slideshow__content');
    var pauzy = {};
    w.style.setProperty('--lv-sp-czas', (czas || 1) + 'ms');
    if (czas) w.classList.add('is-auto');

    function wybrany() {
      var boxy = tresc ? tresc.querySelectorAll('.slideshow__box') : [];
      for (var i = 0; i < boxy.length; i++) if (boxy[i].classList.contains('is-selected')) return i;
      return -1;
    }
    function ustaw(i) {
      biezacy = i;
      paski.forEach(function (p, k) {
        p.classList.remove('is-biezacy', 'is-pelny');
        if (k < i) p.classList.add('is-pelny');
        if (k === i) p.setAttribute('aria-current', 'true'); else p.removeAttribute('aria-current');
      });
      void w.offsetWidth; /* restart animacji paska */
      if (paski[i]) paski[i].classList.add('is-biezacy');
    }
    function idz(i, wrap) {
      var f = komp.flickitySmall, c = komp.flickityContent;
      if (!f) return;
      if (c && f.selectedIndex !== c.selectedIndex) f.select(c.selectedIndex, false, true);
      if (i === biezacy) ustaw(i); else f.select(i, !!wrap);
    }
    /* telefon: min-height pola tekstu i viewportu Flickity (najwyzszy slajd) liczy skrypt w sekcji (sections/slideshow.liquid,
       tresc.lvWyrownaj); tu tylko ponowne liczenie po zmianie rozmiaru, fontach i zaladowaniu strony. */
    function wyrownaj() { if (tresc && tresc.lvWyrownaj) tresc.lvWyrownaj(); }
    wyrownaj();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(wyrownaj);
    var tRozm;
    window.addEventListener('resize', function () { clearTimeout(tRozm); tRozm = setTimeout(wyrownaj, 200); });
    window.addEventListener('load', wyrownaj);
    function pauza(powod, tak) {
      if (tak) pauzy[powod] = 1; else delete pauzy[powod];
      w.classList.toggle('is-pauza', Object.keys(pauzy).length > 0);
      w.dataset.lvPauza = Object.keys(pauzy).join(' ');
    }

    paski.forEach(function (p, k) {
      p.addEventListener('click', function () { idz(k); });
      p.addEventListener('animationend', function (e) {
        if (!czas || k !== biezacy || e.target.tagName !== 'I') return;
        idz((k + 1) % n, true);
      });
    });

    /* zmiana slajdu z dowolnego zrodla (strzalki, przeciagniecie, paski) = nowy stan paskow */
    if (tresc) new MutationObserver(function () {
      var i = wybrany();
      if (i > -1 && i !== biezacy) ustaw(i);
    }).observe(tresc, { subtree: true, attributes: true, attributeFilter: ['class'] });

    /* kursor tylko na urzadzeniach z prawdziwym hover: telefon po stuknieciu wysyla mouseenter bez mouseleave (wieczna pauza) */
    var mysz = window.matchMedia('(hover: hover) and (pointer: fine)');
    [komp, w].forEach(function (el) {
      el.addEventListener('mouseenter', function () { if (mysz.matches) pauza('kursor', true); });
      el.addEventListener('mouseleave', function () { pauza('kursor', false); });
    });
    komp.addEventListener('touchstart', function () { pauza('dotyk', true); }, { passive: true });
    ['touchend', 'touchcancel'].forEach(function (t) { komp.addEventListener(t, function () { pauza('dotyk', false); }, { passive: true }); });
    komp.addEventListener('focusin', function () { pauza('fokus', true); });
    komp.addEventListener('focusout', function () { pauza('fokus', false); });
    document.addEventListener('visibilitychange', function () { pauza('karta', document.hidden); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) {
      pauza('ekran', !e[0].isIntersecting);
    }, { threshold: 0.25 }).observe(komp);

    /* start po zainicjowaniu Flickity przez motyw (initWhenVisible + setTimeout) */
    (function czekaj(proba) {
      if (komp.flickitySmall && wybrany() > -1) { wyrownaj(); w.classList.add('is-gotowe'); ustaw(wybrany()); return; }
      if (proba < 240) setTimeout(function () { czekaj(proba + 1); }, 250);
    })(0);
  }
  function start() { document.querySelectorAll('.lv-slider-paski').forEach(podepnij); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
